import styled from 'styled-components';

import { Card, Button, Progress, Text } from '@gympass/yoga';
import { wellzTheme } from '@wellz-theme/mui';

export const UserInfoContainer = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: ${({ theme }) => theme.yoga.borders.contentHeight};
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
`;

export const ButtonAddActivities = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;

export const ButtonSubscribeToProgram = styled(Button)`
  margin-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;

export const TabsContainer = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const Divisor = styled.hr`
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  margin: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const ProgramSection = styled(Card)`
  & > header {
    & > div {
      border-radius: ${({ theme }) => theme.yoga.spacing.xxsmall}px
        ${({ theme }) => theme.yoga.spacing.xxsmall}px
        ${({ theme }) => theme.yoga.spacing.zero}px
        ${({ theme }) => theme.yoga.spacing.zero}px;
      height: ${({ theme }) => theme.yoga.sizes.linearGradientHeight}px;
      width: calc(
        ${({ theme }) => theme.yoga.sizes.contentWidth} +
          ${({ theme }) => theme.yoga.sizes.linearGradientHeader}px
      );
      margin-left: -${({ theme }) => theme.yoga.sizes.linearGradientLeftMargin}px;
    }
  }
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.xxlarge - 2}px;
  padding: ${({ theme }) => theme.yoga.spacing.large - 1}px
    ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const ActivitiesSection = styled(Card)`
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.xxlarge - 2}px;
  padding: ${({ theme }) => theme.yoga.spacing.large - 1}px
    ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const ActivitiesContent = styled(Card.Content)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.disabled};
`;

export const ActivitiesContentLeft = styled.div``;

export const ActivitiesContentUp = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ActivitiesContentRight = styled.div`
  margin-top: 35px;
`;

export const ProgramHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: ${({ theme }) => theme.yoga.borders.contentWidth};
  background: linear-gradient(
    76.4deg,
    ${({ theme }) => theme.yoga.colors.primary}
      ${({ theme }) => theme.yoga.spacing.zero}%,
    ${({ theme }) => theme.yoga.colors.primaryLight}
      ${({ theme }) => theme.yoga.borders.contentWidth}
  );
`;

export const ActivitiesHeaderContent = styled.div`
  margin: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  display: flex;
  justify-content: space-between;
  width: ${({ theme }) => theme.yoga.borders.contentWidth};
`;

export const ActivitiesTopics = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  width: ${({ theme }) => theme.yoga.borders.contentWidth};
`;

export const ProgressBar = styled(Progress)<{
  isCompleted?: boolean;
}>`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  width: ${({ theme }) => theme.yoga.sizes.progressBarWidth}px;
  progress {
    ::-webkit-progress-value {
      background-color: ${({ isCompleted, theme }) =>
        isCompleted
          ? theme.yoga.colors.success
          : theme.yoga.colors.primaryLight};
    }
    ::-webkit-progress-bar {
      background-color: ${({ theme }) => theme.yoga.colors.backgroundProgress};
    }
    ::-moz-progress-bar {
      background-color: ${({ theme }) => theme.yoga.colors.backgroundProgress};
    }
  }
  label {
    color: ${({ theme }) => theme.yoga.colors.inputDisabled};
  }
`;

export const Dropdown = styled.div<{
  isCollapsed: boolean;
}>`
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.medium}px;
  display: ${({ isCollapsed }) => (isCollapsed ? 'block' : 'none')};
`;

export const TopicsTitle = styled.div`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const TopicsButton = styled(Button.Link)`
  svg {
    fill: ${({ theme }) => theme.yoga.colors.primary};
    margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
    height: ${({ theme }) => theme.yoga.spacing.large}px;
    width: ${({ theme }) => theme.yoga.spacing.large}px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const NoProgramContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  color: ${({ theme }) => theme.yoga.colors.inputDisabled};
  min-height: ${({ theme }) => theme.yoga.colors.noContentHeight}px;
`;

export const NoProgramText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  color: ${({ theme }) => theme.yoga.colors.inputDisabled};
`;

export const NoProgramDescriptionText = styled.div`
  margin: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const NoProgramImage = styled.div`
  margin: ${({ theme }) => theme.yoga.spacing.medium}px;

  svg {
    width: ${wellzTheme.spacing(10)};
    height: ${wellzTheme.spacing(10)};
  }
`;

export const ButtonChangeProgram = styled(Button)`
  background-color: ${({ theme }) => theme.yoga.colors.inputBackground};
  color: ${({ theme }) => theme.yoga.colors.primary};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;

export const ProgramName = styled(Text.H5)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  font-size: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const ActiveProgram = styled(Text.H5)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  font-size: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;
